module.exports = __webpack_public_path__ + "static/img/13.6c3d22d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/4/2/zh/13.png
// module id = NJeQ
// module chunks = 0